import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { companyInfo } from '../mock';
import Logo from './Logo';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="nav-header">
      <div className="flex items-center justify-between w-full max-w-7xl mx-auto">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <Logo width={160} height={45} />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-1">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/services" className="nav-link">Services</Link>
          <Link to="/areas" className="nav-link">Service Areas</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/blog" className="nav-link">Blog</Link>
        </nav>

        {/* CTA Button - Desktop */}
        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${companyInfo.phoneRaw}`} className="btn-primary">
            <Phone size={18} />
            Call Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-border-light shadow-lg">
          <nav className="flex flex-col p-4 gap-2">
            <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link to="/services" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Services</Link>
            <Link to="/areas" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Service Areas</Link>
            <Link to="/about" className="nav-link" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link to="/blog" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
            <a href={`tel:${companyInfo.phoneRaw}`} className="btn-primary mt-2">
              <Phone size={18} />
              Call {companyInfo.phone}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;